const browserConditions = [
  {
    belong: "PC",
    colSpan: 2,
    conditionType: "INPUT",
    domkey: ["keyword"],
    fieldcol: 18,
    isBase64: false,
    isQuickSearch: true,
    label: "案例名称",
    labelcol: 6,
    viewAttr: 2
  },
  {
    belong: "PC",
    colSpan: 2,
    conditionType: "SELECT",
    domkey: ["platform"],
    fieldcol: 18,
    label: "平台",
    labelcol: 6,
    viewAttr: 2,
    options: [
      { key: "all", showname: "全部" },
      { key: "pc", showname: "PC" },
      { key: "mobile", showname: "MOBILE" }
    ]
  },
  {
    belong: "PC",
    colSpan: 2,
    conditionType: "SELECT",
    domkey: ["industry"],
    fieldcol: 18,
    label: "行业",
    otherParams: {
      multiple: true,
      style: { maxWidth: 261 }
    },
    labelcol: 6,
    viewAttr: 2,
    options: []
  },
  {
    belong: "PC",
    colSpan: 2,
    conditionType: "SELECT",
    domkey: ["funtions"],
    fieldcol: 18,
    label: "职能",
    otherParams: {
      multiple: true,
      style: { maxWidth: 261 }
    },
    labelcol: 6,
    viewAttr: 2,
    options: []
  }
];
const quickSearchKey = "keyword";
const filterData = datas => {
  return datas.map(pros => {
    if (pros.funcList) {
      pros.funcList = pros.funcList.map(fun => {
        return {
          ...fun,
          showname: fun.g_name || fun.name,
          key: fun.g_id || fun.key
        };
      });
    }
    return {
      ...pros,
      showname: pros.g_name || pros.name,
      key: pros.g_id || pros.key
    };
  });
};
const dealPropertyList = (conditons, propertyLists) => {
  propertyLists = filterData(propertyLists);
  if (propertyLists && propertyLists.length > 0) {
    conditons[2]["options"] = propertyLists;
    conditons[3]["options"] = getFuncListAll(propertyLists);
  }
  return conditons;
};
const getFuncListAll = (propertyLists = [], industryValue) => {
  let funcListAll = [];
  if (industryValue) {
    const industrys = industryValue.split(",");
    industrys.forEach(indus => {
      const pros = propertyLists.find(pro => pro.key === indus);
      if (pros && pros.funcList) {
        funcListAll = funcListAll.concat(
          pros.funcList.filter(
            fun =>
              !funcListAll.find(v => v.key === fun.key) &&
              fun.key !== "" &&
              fun.key !== "0"
          )
        );
      }
    });
    return funcListAll;
  }
  propertyLists.forEach(pros => {
    if (pros.funcList) {
      // 过滤重复选项及选项：全部
      funcListAll = funcListAll.concat(
        pros.funcList.filter(
          fun =>
            !funcListAll.find(v => v.key === fun.key) &&
            fun.key !== "" &&
            fun.key !== "0"
        )
      );
    }
  });
  return funcListAll;
};
const getBrowserConditions = (params = {}, demotype = "", labels = {}) => {
  const { propertyList = [] } = params;
  const domkeysForLabel = Object.keys(labels);
  const conditions = browserConditions.map(v => {
    const domkey = v.domkey.join();
    if (domkeysForLabel.indexOf(domkey) >= 0) {
      v.label = labels[domkey];
    }
    return v;
  });
  const resConditions = dealPropertyList(conditions, propertyList);
  return demotype === "workflowChart"
    ? resConditions
    : resConditions.slice(0, 3);
};

export default {
  quickSearchKey,
  browserConditions,
  getFuncListAll,
  getBrowserConditions,
  filterData
};



// WEBPACK FOOTER //
// ./ecology9/base/wea-ecode-browser/constants.js